import type { ComponentProps } from 'react';
import { cn } from './cn.ts';

/** shadcn's input on the kit's tokens: a 10 px white box, a red ring on focus, red edge when invalid. */
export const inputBox =
  'rounded-control border border-line-strong bg-surface px-s3 text-ink placeholder:text-muted focus-visible:border-brand focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-brand disabled:cursor-default disabled:bg-sunk disabled:text-muted aria-invalid:border-late-ink';
export const inputClass = `h-control text-field ${inputBox}`;

export function UiInput({ className, ...props }: ComponentProps<'input'>) {
  return <input data-slot="input" className={cn(inputClass, className)} {...props} />;
}
